import {Component, OnDestroy, OnInit} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {filter, finalize, takeUntil, withLatestFrom} from "rxjs/operators";

@Component({
    selector: "app-contact",
    templateUrl: "./contact.component.html",
    styleUrls: ["./contact.component.scss"]
})
export class ContactComponent implements OnInit, OnDestroy {

    private readonly email$ = new Subject<boolean>()
    public readonly submitted$ = new BehaviorSubject(false)

    public readonly submitting$ = new BehaviorSubject<boolean>(false)
    public readonly submitError$ = new BehaviorSubject<string | null>(null)
    private readonly destroyed$ = new Subject<boolean>()

    public readonly name = new FormControl(null, Validators.required)
    public readonly email = new FormControl(null, [Validators.required, Validators.email])
    public readonly message = new FormControl(null, Validators.required)

    public readonly form = new FormGroup({
        name: this.name,
        email: this.email,
        message: this.message
    })

    constructor(private readonly http: HttpClient) {
    }

    public ngOnInit() {
        this.email$
            .pipe(takeUntil(this.destroyed$))
            .pipe(withLatestFrom(this.form.valueChanges, this.form.statusChanges))
            .pipe(filter(([_, formData, status]) => status === "VALID"))
            .subscribe(([_, formData]) => this.sendEmailRequest(formData))
    }

    public submit() {
        this.email$.next(true)
    }

    private sendEmailRequest(formData: FormData) {

        const data = {
            ...formData,
            phone: null,
            page: "CONTACT"
        }

        this.submitted$.next(false)
        this.submitting$.next(true)
        this.submitError$.next(null)

        this.http
            .post("/tradefloor/public_api/email", data)
            .pipe(takeUntil(this.destroyed$))
            .pipe(finalize(() => this.submitting$.next(false)))
            .subscribe(() => this.resetForm(),
                (errorResponse) => this.submitError(errorResponse))
    }

    private resetForm() {
        this.submitted$.next(true)
        this.form.reset()
    }

    private submitError(errorResponse: HttpErrorResponse) {
        this.submitError$.next(this.extractErrorMessage(errorResponse))
    }

    private extractErrorMessage(errorResponse: HttpErrorResponse) {
        switch (errorResponse.status) {
            case 503:
                return "We are performing maintenance. Please try again later."
            default:
                return "There was an error processing your request. Please try again later."
        }
    }

    public ngOnDestroy(): void {
        this.destroyed$.next(true)
        this.destroyed$.complete()
    }
}
